import { LogLevel } from '@azure/msal-browser';
import type { Configuration } from '@azure/msal-browser';

const domainAdb2c = import.meta.env.VITE_AUTH_DOMAIN_ADB2C;
const signinPolicyAdb2c = import.meta.env.VITE_AUTH_SIGNIN_POLICY_ADB2C;

const authority = domainAdb2c
  ? `https://${domainAdb2c}.b2clogin.com/${domainAdb2c}.onmicrosoft.com/${signinPolicyAdb2c}`
  : `https://login.microsoftonline.com/${import.meta.env.VITE_AUTH_TENANT_ID}`;

const knownAuthorities = domainAdb2c ? [`${domainAdb2c}.b2clogin.com`] : [];

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    authority,
    knownAuthorities,
    redirectUri: document.baseURI,
    postLogoutRedirectUri: document.baseURI,
  },
  cache: {
    cacheLocation: import.meta.env.VITE_AUTH_TOKEN_CACHE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          case LogLevel.Error:
            console.error(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};

export const loginRequest = {
  scopes: import.meta.env.VITE_AUTH_SCOPES.split(', '),
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
